export default "__VITE_ASSET__B8DGfOL2__"